import styled from "styled-components";
const NavbarSc = styled.div`
  background: rgb(111, 45, 137);

  background: linear-gradient(
    90deg,
    rgba(111, 45, 137, 1) 11%,
    rgba(45, 53, 146, 1) 62%,
    rgba(164, 39, 79, 1) 91%
  );
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* align-items: center; */
  cursor: pointer;
  top: 0px;
  z-index: 1;
  padding: 0.5px;
  .navbar_whole_component {
    display: flex;
    justify-content: space-between;
  }
  .nav-bar-xbi4-white-logo-in {
    width: 140px;
    /* height:120px */
    padding: 0px 20px;
  }
  .navbar-rightside-comp {
    display: flex;
    gap: 20px;
    padding: 0px 25px;
    align-items: center;
  }
  .nav-bar-left-side-logos {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    transition: 1s;
  }

  .dropdown {
    position: relative;
  }
  .dropbtn {
    color: white;
    padding: 16px;
    font-size: 16px;
    border: none;
    cursor: pointer;
  }

  .dropdown-content {
    display: none;
    flex-direction: column;
    flex-wrap: wrap;
    border: 1px solid black;
    padding: 0px 5px;
    width: 100vw;
    position: absolute;
    background: whitesmoke;
    z-index: 1;
    border-radius: 0px 0px 10px 10px;
    color: black;
  }
  .drop-down-list {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }

  .wrap-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 1rem;
  }
  .icon-item {
    color: #000000;
    font-weight: bolder;
    width: 100%;
    background-color: #d9d9d9;
    height: 50px;
    padding: 1rem 1.5rem;
  }
  .modules {
    border-radius: 2px;
    width: 280px;
    align-content: center;
    justify-content: center;
  }
  .modules > div {
    padding: 1rem;
  }
  .modules:hover {
    border-radius: 2px;
    box-sizing: content-box;
  }
  /* .dropdown:hover .dropdown-content {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    border: 1px solid black;
    padding: 0px 2px;
    width: 100vw;
    position: absolute;
    background: whitesmoke;
    z-index: 10;
    border-radius: 0px 0px 10px 10px;
    color: black;
  } */
  .dropdown_content_click {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    border: 1px solid black;
    padding: 0px 2px;
    width: 100vw;
    position: absolute;
    background: whitesmoke;
    z-index: 10;
    border-radius: 0px 0px 10px 10px;
    color: black;
  }
  .dropdown:hover .nav-bar-xbi4-white-logo-in {
    transform: scale(1);
  }
  .navbar-rightside-notify-logo {
    width: 30px;
  }

  .greeting-name {
    color: whitesmoke;

    font-size: large;
  }
  .profile-drop-down {
    position: relative;
    display: flex;
    width: 35px;
    height: 35px;
  }
  .navbar-profile-pic-btn {
    color: white;

    border-radius: 100%;
    width: 35px;
    height: 35px;
    font-size: 16px;
    border: none;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;

    background: rgba(111, 45, 164, 0.75);
    box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
    backdrop-filter: blur(0px);
    -webkit-backdrop-filter: blur(0px);
  }
  .profile-pic-drop-down-content {
    display: none;
    flex-direction: column;
    position: absolute;
    top: 38px;
    right: 1px;
    background: rgba(111, 45, 164, 0.75);
    box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
    backdrop-filter: blur(0px);
    -webkit-backdrop-filter: blur(0px);
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.18);
    width: 200px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
    flex-wrap: wrap;
    border-radius: 10px;
    color: #ffffff;
  }
  .profile-pic-drop-down-content > div {
    padding: 12px 16px;
    text-decoration: none;
    display: flex;
  }
  .t-icon {
    width: 200px;
    display: flex;
    justify-content: space-between;
    color: #ffffff;
  }
  .profile-drop-down:hover .profile-pic-drop-down-content {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 36px;
    right: 1px;
    width: 200px;
    background: rgba(111, 45, 164, 0.75);
    box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
    backdrop-filter: blur(0px);
    -webkit-backdrop-filter: blur(0px);
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.18);
    visibility: visible;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
    border-radius: 5px;
    color: #ffffff;
  }
  .navbar-rightside-logout-logo {
    width: 25px;
    color: #ffffff;
  }
  .icons-label {
    display: flex;
    flex-wrap: wrap;
  }
  .hamburger-menu {
    display: none;
  }
  @media (max-width: 700px) {
    .navbar-rightside-comp {
      display: none;
    }

    .nav-bar-left-side-logos {
      justify-content: center;
    }

    .dropdown-content {
      width: 100%;
    }

    .navbar-profile-pic-btn {
      display: none;
    }

    .greeting-name {
      display: none;
    }
    .hamburger-menu {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 10%;
      height: 10%;
      position: relative;
    }

    .menu-button {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 45px;
      height: 45px;
      background-color: transparent;
      border: none;
      cursor: pointer;
    }

    .bar {
      width: 25px;
      height: 3px;
      background-color: #333;
      margin: 4px 0;
      transition: transform 0.2s ease-in-out;
    }

    .open .bar:nth-child(1) {
      transition: all 100ms ease-in-out;
      transform: rotate(55deg);
      transform-origin: top left;
      width: 28px;
    }

    .open .bar:nth-child(2) {
      transition: all 100ms ease-in-out;
      transform-origin: center;
      width: 0;
    }

    .open .bar:nth-child(3) {
      transition: all 100ms ease-in-out;
      transform: rotate(-55deg);
      transform-origin: bottom left;
      width: 28px;
    }
    .main-modal-container {
      background: #ffffff;
      width: 300px;
      height: 100%;
      display: flex;
      flex-direction: column;
      position: fixed;
      top: 50px;
      right: 0;
      transition: width 1s ease-in-out;
      z-index: 10;
      overflow-y: scroll;
      border-radius: 5px;
      padding: 1.5rem;
    }
    .drop-down-heading {
      display: flex;
      padding: 0.8rem;
      margin-left: 3px;
      color: #fff;
      margin-bottom: 10px;
    }
    .list-container {
    }
    .dropdown:hover .dropdown-content {
      display: none;
    }
  }
  .toast_container{
    position: absolute;
    bottom: 0;
    right: 0;
  }
`;
export default NavbarSc;
